/* unplugin-vue-components disabled */import { render } from "./WebsiteUpdatesBanner.vue?vue&type=template&id=387f3e24"
import script from "./WebsiteUpdatesBanner.vue?vue&type=script&lang=js"
export * from "./WebsiteUpdatesBanner.vue?vue&type=script&lang=js"

import "./WebsiteUpdatesBanner.vue?vue&type=style&index=0&id=387f3e24&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__